export const urls = {
//baseUrl: "http://localhost:8082/ava-seleccion",
baseUrl: "http://planticco.avaseleccion.com/ava-pruebas",
//baseUrl: "https://json-server-app-nkhg.onrender.com",
}
